module.exports = __webpack_public_path__ + "static/sparkjop-9366abd1c4f85d18ed5df398a80e013f.png";